import {DatePipe} from '@angular/common';
import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
	standalone: false,name: 'dateDisplay'})
export class DateFormatPipe implements PipeTransform {
	transform(value: any, pattern = 'mediumDate'): any {
		if (!(value instanceof Date)) {
			value = new Date(value);
		}
		const datePipe: DatePipe = new DatePipe('fr');
		return datePipe.transform(value, pattern);
	}
}
